import { useState } from 'react'
import { Box, Button } from '@mui/material'
import { COLORS } from './theme'
import { primaryButtonSx, outlinedButtonSx } from './styles'
import { STEPS, getContentWidth } from './onboardingSteps'
import { useOnboardingV2 } from './OnboardingContext'

export default function OnboardingNavButtons() {
  const { currentStep, totalSteps, canContinue, advanceStep, retreatStep, hideNav, continueLabel, hideBackButton, hideContinueButton } = useOnboardingV2()
  const [advancing, setAdvancing] = useState(false)
  const [retreating, setRetreating] = useState(false)

  if (hideNav) return null

  const hideBack = currentStep <= STEPS.INTRO_VIDEO
  const isLastStep = currentStep === totalSteps

  const handleNext = async () => {
    setAdvancing(true)
    try {
      await advanceStep()
    } finally {
      setAdvancing(false)
    }
  }

  const handleBack = async () => {
    setRetreating(true)
    try {
      await retreatStep()
    } finally {
      setRetreating(false)
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: 2,
        width: '100%',
        maxWidth: (() => {
          const cw = getContentWidth(currentStep)
          return cw === 'full' ? 720 : Math.min(cw, 720)
        })(),
        mx: 'auto',
        mt: 3,
        px: 2,
      }}
    >
      {!hideBack && !hideBackButton ? (
        <Button
          disableRipple
          variant="outlined"
          onClick={handleBack}
          disabled={advancing || retreating}
          tabIndex={100}
          sx={{
            ...outlinedButtonSx,
            px: 4,
            py: 1,
            fontSize: '16px',
          }}
        >
          Back
        </Button>
      ) : null}
      {!hideContinueButton && (
        <Button
          disableRipple
          variant="contained"
          onClick={handleNext}
          disabled={!canContinue || advancing || retreating}
          tabIndex={99}
          sx={{
            ...primaryButtonSx,
            px: 4,
            py: 1,
            fontSize: '16px',
            '&:disabled': {
              bgcolor: COLORS.border,
              color: COLORS.muted,
            },
          }}
        >
          {advancing ? 'Saving...' : continueLabel ?? (isLastStep ? 'Finish' : 'Continue')}
        </Button>
      )}
    </Box>
  )
}
